import React, { useState, useContext } from "react"
import { TrashIcon, CollectionIcon, PencilIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import { AuthContext } from "../../context/auth.context"
import Button from "../atoms/button.atom"
import Modal from "../atoms/modal.atom"
import { toast } from "react-toastify"
import { Header } from "../common/header"
import Loader from "../loader/loader.component"

export const TemplateTable = ({ hubId, onAddTemplate, onUpdateTemplate }) => {
	const { auth, setAuth } = useContext(AuthContext)
	const [loading, setLoading] = useState(false)
	const [isModalVisible, setIsModalVisible] = React.useState(false)
	const [templateId, setTemplateId] = React.useState()
	const [serverTemplates, setServerTemplates] = useState([])

	const getTemplates = () => {
		setLoading(true)
		;(async () => {
			const res = await axiosInstance.get(EndpointConfig.VFSMSTemplates, {
				headers: {
					"hub-id": hubId
				}
			})
			setServerTemplates(res.data.data)
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		getTemplates()
	}, [])

	const deleteTemplate = () => {
		setIsModalVisible(false)
		setLoading(true)
		;(async () => {
			await axiosInstance.delete(EndpointConfig.VFSMSTemplates, {
				headers: {
					"hub-id": hubId
				},
				data: {
					templateId
				}
			})
			toast("Deleted Successfully")
			getTemplates()
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const editTemplate = ({ templateId }) => {
		setLoading(true)
		;(async () => {
			const res = await axiosInstance.get(EndpointConfig.VFSMSTemplates, {
				headers: {
					"hub-id": hubId
				},
				data: {
					templateId
				}
			})
			const selectedData = res.data.data.find((c) => c._id === templateId)
			setAuth({ hubId: hubId, passData: selectedData })
			onUpdateTemplate()
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	return (
		<>
			<Modal
				children={
					<div className="flex font-sans">
						<form className="flex-auto p-6">
							<div className="flex flex-wrap">
								<h1 className="flex-auto text-lg font-semibold text-slate-900">
									Delete
								</h1>
								<div className="flex-none w-full mt-2 text-sm font-normal text-slate-700">
									Are you sure you want to delete this template? Click Yes to
									Proceed.!
								</div>
							</div>
							<div className="flex my-5 mb-1 space-x-4 text-sm font-medium">
								<div className="flex items-end justify-end flex-auto space-x-4">
									<button
										className="h-10 px-6 font-semibold text-white bg-blue-700 rounded-md"
										type="submit"
										onClick={() => deleteTemplate()}
									>
										Yes
									</button>
									<button
										className="h-10 px-6 font-semibold border rounded-md border-slate-500 text-slate-900"
										type="button"
										onClick={() => setIsModalVisible(false)}
									>
										No
									</button>
								</div>
							</div>
						</form>
					</div>
				}
				toggle={() => setIsModalVisible(false)}
				open={isModalVisible}
			/>
			<div className="flex flex-col">
				<Header
					IconName={CollectionIcon}
					subText={"List"}
					mainText={"SMS Templates"}
					postComponent={
						<Button className="w-full" onClick={onAddTemplate}>
							Add New Template
						</Button>
					}
				/>

				{loading ? (
					<Loader />
				) : (
					<>
						<div className="flex flex-col pb-4 overflow-x-auto bg-white rounded">
							<div className="inline-block py-2">
								<table className="common">
									<thead className="">
										<tr className="">
											{/* <th className="">Template ID</th> */}
											<th className="">Template Name</th>
											<th className="">Module</th>
											<th className="">Sender Id</th>
											<th className="">User Id</th>
											<th className="">Status</th>
											<th className="">Template Text</th>
											<th className="">Action</th>
										</tr>
									</thead>
									<tbody>
										{serverTemplates.map((template) => (
											<tr key={template._id}>
												{/* <td className=""> {template._id} </td> */}
												<td className="font-medium">{template.name}</td>
												<td className="">{template.module}</td>
												<td className="">{template.senderId}</td>
												<td className="">{template.userId}</td>
												<td className="">{template.status}</td>
												<td className="">{template.text}</td>
												<td className="">
													<div className="flex flex-row gap-2">
														{/* <ChatIcon className="w-4 h-4 text-red-500 cursor-pointer" onClick={() => { }} /> */}
														<TrashIcon
															className="w-4 h-4 text-red-500 cursor-pointer"
															onClick={() => {
																setTemplateId(template._id)
																setIsModalVisible(true)
															}}
														/>
														<PencilIcon
															className="w-4 h-4 text-blue-500 cursor-pointer"
															onClick={() =>
																editTemplate({
																	templateId: template._id
																})
															}
														/>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</>
				)}
			</div>
		</>
	)
}
